// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type InvoicePageStatusQueryVariables = Types.Exact<{
  invoiceId: Types.Scalars['ID']['input'];
}>;


export type InvoicePageStatusQuery = { __typename?: 'Query', invoice: { __typename?: 'Invoice', id: string, status: { __typename?: 'InvoiceStatusDetail', code: Types.InvoiceStatus } } };

export type InvoiceV2_Parent_PlanMilestone_Fragment = { __typename?: 'PlanMilestone', id: string, name: string, completedDate?: Types.Scalars['DateTime']['input'] | null | undefined, taskStatusRollup: { __typename?: 'TaskStatusDetail', code: Types.TaskStatus } };

export type InvoiceV2_Parent_Task_Fragment = { __typename?: 'Task', id: string, completedAt?: Types.Scalars['Date']['input'] | null | undefined, name: string, status: { __typename?: 'TaskStatusDetail', code: Types.TaskStatus } };

export type InvoiceV2_Parent_ScheduleTask_Fragment = { __typename?: 'ScheduleTask', id: string, completedAt?: Types.Scalars['Date']['input'] | null | undefined, name: string, schedule: { __typename?: 'Schedule', id: string, stageDetail: { __typename?: 'StageDetail', code: Types.Stage } }, statusDetail: { __typename?: 'TaskStatusDetail', code: Types.TaskStatus }, assignee?: { __typename?: 'InternalUser', id: string, name: string } | null | undefined };

export type InvoiceV2_Parent_PlanTask_Fragment = { __typename?: 'PlanTask', id: string, name: string, completedDate?: Types.Scalars['DateTime']['input'] | null | undefined, status: { __typename?: 'TaskStatusDetail', code: Types.TaskStatus } };

export type InvoiceV2_ParentFragment =
  | InvoiceV2_Parent_PlanMilestone_Fragment
  | InvoiceV2_Parent_Task_Fragment
  | InvoiceV2_Parent_ScheduleTask_Fragment
  | InvoiceV2_Parent_PlanTask_Fragment
;

export const InvoiceV2_ParentFragmentDoc = gql`
    fragment InvoiceV2_Parent on InvoiceParent {
  ...Named
  ... on Task {
    id
    completedAt
    status {
      code
    }
  }
  ... on ScheduleTask {
    id
    completedAt
    schedule {
      id
      stageDetail {
        code
      }
    }
    statusDetail {
      code
    }
    assignee {
      ...Named
    }
  }
  ... on PlanTask {
    id
    completedDate: completedAt
    status {
      code
    }
  }
  ... on PlanMilestone {
    id
    completedDate: completedAt
    taskStatusRollup {
      code
    }
  }
}
    ${NamedFragmentDoc}`;
export const InvoicePageStatusDocument = gql`
    query InvoicePageStatus($invoiceId: ID!) {
  invoice(id: $invoiceId) {
    id
    status {
      code
    }
  }
}
    `;

/**
 * __useInvoicePageStatusQuery__
 *
 * To run a query within a React component, call `useInvoicePageStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicePageStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicePageStatusQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useInvoicePageStatusQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InvoicePageStatusQuery, InvoicePageStatusQueryVariables> & ({ variables: InvoicePageStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InvoicePageStatusQuery, InvoicePageStatusQueryVariables>(InvoicePageStatusDocument, options);
      }
export function useInvoicePageStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InvoicePageStatusQuery, InvoicePageStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InvoicePageStatusQuery, InvoicePageStatusQueryVariables>(InvoicePageStatusDocument, options);
        }
// @ts-ignore
export function useInvoicePageStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<InvoicePageStatusQuery, InvoicePageStatusQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InvoicePageStatusQuery, InvoicePageStatusQueryVariables>;
export function useInvoicePageStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InvoicePageStatusQuery, InvoicePageStatusQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<InvoicePageStatusQuery | undefined, InvoicePageStatusQueryVariables>;
export function useInvoicePageStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InvoicePageStatusQuery, InvoicePageStatusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InvoicePageStatusQuery, InvoicePageStatusQueryVariables>(InvoicePageStatusDocument, options);
        }
export type InvoicePageStatusQueryHookResult = ReturnType<typeof useInvoicePageStatusQuery>;
export type InvoicePageStatusLazyQueryHookResult = ReturnType<typeof useInvoicePageStatusLazyQuery>;
export type InvoicePageStatusSuspenseQueryHookResult = ReturnType<typeof useInvoicePageStatusSuspenseQuery>;
export type InvoicePageStatusQueryResult = Apollo.QueryResult<InvoicePageStatusQuery, InvoicePageStatusQueryVariables>;